<template>
  <ml-studio-application-page v-if="enabled" />
  <m-l-studio-promotion-page v-else />
</template>

<script>
import MlStudioApplicationPage from './MlStudioApplicationPage'
import MLStudioPromotionPage from './MlStudioPromotionPage'
import { $hasFeature } from '@/core/utils/VueAcl'

export default {
  name: 'MlStudioPage',

  components: { MLStudioPromotionPage, MlStudioApplicationPage },

  computed: {
    enabled() {
      if (!$hasFeature('mlStudio')) {
        return false
      }

      const user = this.$store.state.app.user
      const canUserAccessInfinityAI =
        user.role === 'admin' || user.role === 'admin-support'
          ? true
          : user.infinityai

      return this.$can('MLStudio:ReadAccess') && canUserAccessInfinityAI
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/ml-studio/pages/MlStudioPage.vue